import { ThunkAction, Dispatch } from 'redux-thunk';
import { AppState } from '../reducers';
import getConfig from '../../config';

export function forwardToDolphinCms(
  urlParam: string = ''
): ThunkAction<void, AppState, void> {
  return async (dispatch: Dispatch<AppState>) => {
    window.location.href = `${getConfig().dolphinCmsEndpoint}/wizard/${
      urlParam ? `?${urlParam}` : ''
    }`;
  };
}
